import { message } from 'antd';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { addReportToMyLibraryAPI, deleteUserCaseAPI, fetchReportUserCaseAPI, updateMyLibraryUserCaseAPI } from '../../../services/user-case-service';
import { fetchMyLibraryUserCasesAPI } from '../../../services/user-case-service';
import { ADD_REPORT_TO_MY_LIBRARY, ADD_REPORT_TO_MY_LIBRARY_ERROR, ADD_REPORT_TO_MY_LIBRARY_SUCCESS, ADD_UPDATE_USER_CASE, ADD_UPDATE_USER_CASE_ERROR, ADD_UPDATE_USER_CASE_SUCCESS, DELETE_USER_CASE, DELETE_USER_CASE_ERROR, DELETE_USER_CASE_SUCCESS, FETCH_MY_LIBRARY_USER_CASES, FETCH_MY_LIBRARY_USER_CASES_ERROR, FETCH_MY_LIBRARY_USER_CASES_START, FETCH_MY_LIBRARY_USER_CASES_SUCCESS, FETCH_REPORT_USER_CASE, FETCH_REPORT_USER_CASE_ERROR, FETCH_REPORT_USER_CASE_SUCCESS, MY_LIBRARY_PAGINATION, SET_MY_LIBRARY_FILTER } from '../../actions/LibraryAction';

const getMessageText = (error, fallback = 'Something went wrong!') => {
    if (!error) {
        return fallback;
    }
    if (typeof error === 'string') {
        return error;
    }
    if (error.message) {
        return error.message;
    }
    return fallback;
}

function* fetchMyLibraryUserCases({ payload }) {

    try {
        yield put({ type: FETCH_MY_LIBRARY_USER_CASES_START })
        let response = yield call(fetchMyLibraryUserCasesAPI, payload);

        if (response.success) {
            const pagination = {
                currentPage: payload.pageNo,
                pageSize: payload.pageSize,
                totalPages: response.data.totalPages,
                totalItems: response.data.totalItems,
            }
            yield put({ type: FETCH_MY_LIBRARY_USER_CASES_SUCCESS, myLibrary: response.data.userCases })
            yield put({ type: MY_LIBRARY_PAGINATION, pagination: pagination });
            yield put({ type: SET_MY_LIBRARY_FILTER, searchFilter: { ...payload.userCaseRequest } });
        } else {
            yield put({ type: FETCH_MY_LIBRARY_USER_CASES_ERROR });
            message.error('Failed to fetch user cases!');
        }

    } catch (error) {
        message.error('Failed to fetch user cases!');
        yield put({ type: FETCH_MY_LIBRARY_USER_CASES_ERROR, error })
    }
}

function* addReportToMyLibrary({ payload }) {

    try {

        let response = yield call(addReportToMyLibraryAPI, payload);

        if (response.success) {
            yield put({ type: ADD_REPORT_TO_MY_LIBRARY_SUCCESS, myLibrary: response.data })
            yield put({ type: FETCH_REPORT_USER_CASE_SUCCESS, userCase: response.data })

            message.success('Added report to library.');

        } else {
            yield put({ type: ADD_REPORT_TO_MY_LIBRARY_ERROR });
            if (response.error === "query did not return a unique result: 2; nested exception is javax.persistence.NonUniqueResultException: query did not return a unique result: 2") {
                message.error('Failed to add report to library!');
            } else {
                message.error(response.error);
            }
        }

    } catch (error) {
        message.error(getMessageText(error, 'Failed to add report to library!'));
        yield put({ type: ADD_REPORT_TO_MY_LIBRARY_ERROR, error })
    }
}

function* addUpdateUserCaseToMyLibrary({ payload }) {
    try {
        let response = yield call(updateMyLibraryUserCaseAPI, payload);
        if (response.success) {
            yield put({ type: ADD_UPDATE_USER_CASE_SUCCESS, userCase: response.data })
            message.success('updated user case successfully.');
        } else {
            yield put({ type: ADD_UPDATE_USER_CASE_ERROR });
            message.error('Failed to update user case!');
        }
    } catch (error) {
        message.error(getMessageText(error, 'Failed to update user case!'));
        yield put({ type: ADD_UPDATE_USER_CASE_ERROR, error })
    }
}

function* deleteUserCase({ payload }) {
    try {
        let response = yield call(deleteUserCaseAPI, payload);
        if (response.success) {
            yield put({ type: DELETE_USER_CASE_SUCCESS, caseId: payload })
            message.success('deleted user case successfully.');
        } else {
            yield put({ type: DELETE_USER_CASE_ERROR });
            message.error('Failed to delete user case!');
        }
    } catch (error) {
        message.error(getMessageText(error, 'Failed to delete user case!'));
        yield put({ type: DELETE_USER_CASE_ERROR, error })
    }
}

function* fetchReportUserCase({ payload }) {
    try {
        let response = yield call(fetchReportUserCaseAPI, payload);
        if (response && response.success) {
            yield put({ type: FETCH_REPORT_USER_CASE_SUCCESS, userCase: response.data !== null ? response.data : null })
        } else {
            yield put({ type: FETCH_REPORT_USER_CASE_ERROR });
        }
    } catch (error) {
        message.error(getMessageText(error, 'Failed to fetch report user case!'));
        yield put({ type: FETCH_REPORT_USER_CASE_ERROR, error })
    }
}


function* myLibraryWatcher() {
    yield takeLatest(FETCH_MY_LIBRARY_USER_CASES, fetchMyLibraryUserCases)
    yield takeLatest(ADD_REPORT_TO_MY_LIBRARY, addReportToMyLibrary)
    yield takeLatest(ADD_UPDATE_USER_CASE, addUpdateUserCaseToMyLibrary)
    yield takeLatest(DELETE_USER_CASE, deleteUserCase)
    yield takeLatest(FETCH_REPORT_USER_CASE, fetchReportUserCase)
}

export default function* rootSaga() {
    yield all([
        myLibraryWatcher()
    ]);
}
